import clsx from "clsx";
import React, {useMemo} from "react"
import {useSiren} from "./SirenContext";

export type ToastType = "success" | "error"


export function ToastMessage() {
    const {toastMessage, toastType} = useSiren();

    const containerClass = useMemo(() => {
        return clsx(
            "text-white text-center p-2",
            {
                "bg-green": toastType == "success",
                "bg-red": toastType == "error",
            }
        )
    }, [toastType]);

    if (!toastMessage || !toastType) {
        return null
    }
    return (
        <div className={containerClass}>
            {toastMessage}
        </div>
    )
}